<template>
  <div id="personal_area">
    <div v-show="type === 'change'" class="head_message"><span>変更されるエリアのみ、入力してください</span></div>
    <SegmentName>ご本人について</SegmentName>
    <div class="table_block">
      <table>
        <tbody>
          <TableTr v-show="thirdParty.keiyakun.is_use">
            <TableTh :isError="false">
              けいやくん契約書面番号
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="8" class="u-w--240">
                  <el-input
                    v-model="thirdParty.keiyakun.no"
                    placeholder="けいやくん契約書面番号"
                  />
                </el-col>
                <el-col style="width: auto;">
                  <el-button class="keiyakun-button" @click="seachKeiyakunContract()">契約情報を取得する</el-button>
                  <el-button class="keiyakun-button" @click="clearKeiyakunInputs()">クリア</el-button>
                </el-col>
              </el-row>
              <FormNotice>けいやくん契約情報連携により、契約情報を取得する場合は、<br>上記にお客様の契約番号を入力し、「契約情報を取得する」ボタンをタップしてください。</FormNotice>
            </td>
          </Tabletr>
          <TableTr v-show="formUserInputFields.applicationDate.isShow">
            <TableTh :isError="false">
              申込日
              <RequiredText v-show="formUserInputFields.applicationDate.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="6" class="u-w--200">
                  <el-select
                    name="application_date_year"
                    placeholder=""
                    v-model="form.application_date_year"
                    @change="onChangeApplicationDate"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.ApplicationYears()"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
                <el-col :span="4" class="u-w--150">
                  <el-select
                    name="application_date_month"
                    placeholder=""
                    v-model="form.application_date_month"
                    @change="onChangeApplicationDate"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.Months"
                      :key="key"
                      :label="`${item.value}月`"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="4" class="u-w--150">
                  <el-select
                    name="application_date_day"
                    placeholder=""
                    v-model="form.application_date_day"
                    @change="onChangeApplicationDate"
                  >
                    <el-option
                      v-for="(item, key) in applicationDays"
                      :key="key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <ErrorMessage class="error-application_date-required"></ErrorMessage>
              <ErrorMessage class="error-application_date-date"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.purposeOfTransaction.isShow">
            <TableTh :isError="false">
              取引を行う目的
              <RequiredText v-show="formUserInputFields.purposeOfTransaction.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="7" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.purposeOfTransaction.key"
                    v-model="form.purpose_of_transaction"
                    @change="onChangepurposeOfTransaction($event)"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputFields.purposeOfTransaction.choices"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
                <el-col :span="8" class="u-w--240">
                  <el-input
                    :name="formUserInputFields.purposeOfTransactionOtherName.key"
                    placeholder=""
                    v-model="form.purpose_of_transaction_other_name"
                    :disabled="form.purpose_of_transaction !== 'その他'"
                    data-validator-name="purpose_of_transaction_other_name_require"
                  />
                </el-col>
              </el-row>
              <ErrorMessage class="error-purpose_of_transaction-required"></ErrorMessage>
              <ErrorMessage class="error-purpose_of_transaction_other_name-required_if"></ErrorMessage>
              <ErrorMessage class="error-purpose_of_transaction_other_name-string"></ErrorMessage>
              <ErrorMessage class="error-purpose_of_transaction_other_name-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.isForeignGovernment.isShow">
            <TableTh :isError="false">
              外国政府等重要な公的地位にある方等とのお取引に該当する
              <RequiredText v-show="formUserInputFields.isForeignGovernment.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="15" class="u-w--400">
                  <InputRadio
                    name="is_foreign_government"
                    :choices="formUserInputFields.isForeignGovernment.choices"
                    :inputRadioVal.sync="form.is_foreign_government"
                    :handleChange="
                      ($event) => {
                        onChangeIsForeignGovernment($event)
                      }
                    "
                  />
                  <el-input
                    :name="formUserInputFields.foreignGovernmentCompany.key"
                    v-model="form.foreign_government_company"
                    :disabled="form.is_foreign_government !== 'はい'"
                    :placeholder="formUserInputFields.foreignGovernmentCompany.placeholder"
                  />
                </el-col>
              </el-row>
              <ErrorMessage class="error-is_foreign_government-required"></ErrorMessage>
              <ErrorMessage class="error-foreign_government_company-required_if"></ErrorMessage>
              <ErrorMessage class="error-foreign_government_company-string"></ErrorMessage>
              <ErrorMessage class="error-foreign_government_company-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.name.isShow">
            <TableTh :isError="false">
              氏名 漢字
              <RequiredText v-show="formUserInputFields.name.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <div class="d-flex flex-shrink-0 mr-2">
                  <el-col class="u-w--50"><FormLabel>姓</FormLabel></el-col>
                  <el-col :span="7" class="u-w--200 flex-shrink-0">
                    <el-input
                      placeholder=""
                      maxlength="10"
                      name="surname"
                      data-validator-name="surname_require"
                      v-model="form.surname"
                      :id="formUserInputFields.name.surname.key"
                      @input="handleSurnameInput()"
                    />
                  </el-col>
                </div>
                <div class="d-flex flex-shrink-0">
                  <el-col class="u-w--50"><FormLabel>名</FormLabel></el-col>
                  <el-col :span="7" class="u-w--200 flex-shrink-0">
                    <el-input
                      placeholder=""
                      maxlength="10"
                      name="first_name"
                      data-validator-name="name_require"
                      v-model="form.first_name"
                      :id="formUserInputFields.name.firstName.key"
                      @input="handleNameInput()"
                    />
                  </el-col>
                </div>
              </el-row>
              <FormNotice>氏名は必ず全角文字で入力してください</FormNotice>
              <ErrorMessage class="error-name-required"></ErrorMessage>
              <ErrorMessage class="error-name-string"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.nameKana.isShow">
            <TableTh :isError="false">
              氏名 フリガナ
              <RequiredText v-show="formUserInputFields.nameKana.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <div class="d-flex flex-shrink-0 mr-2">
                  <el-col class="u-w--50"><FormLabel>セイ</FormLabel></el-col>
                  <el-col :span="7" class="u-w--200 flex-shrink-0">
                    <el-input
                      placeholder=""
                      maxlength="10"
                      name="surname_kana"
                      data-validator-name="surname_kana_require"
                      v-model="form.surname_kana"
                      :id="formUserInputFields.nameKana.surname.key"
                    />
                  </el-col>
                </div>
                <div class="d-flex flex-shrink-0">
                  <el-col class="u-w--50"><FormLabel>メイ</FormLabel></el-col>
                  <el-col :span="7" class="u-w--200 flex-shrink-0">
                    <el-input
                      placeholder=""
                      maxlength="10"
                      name="first_name_kana"
                      data-validator-name="name_kana_require"
                      v-model="form.first_name_kana"
                      :id="formUserInputFields.nameKana.firstName.key"
                    />
                  </el-col>
                </div>
              </el-row>
              <FormNotice>カナ氏名は必ず全角カタカナ文字で入力してください</FormNotice>
              <ErrorMessage class="error-name_kana-required"></ErrorMessage>
              <ErrorMessage class="error-name_kana-string"></ErrorMessage>
              <ErrorMessage class="error-name_kana-kana"></ErrorMessage>
              <ErrorMessage class="error-name_kana-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.oldSurname.isShow">
            <TableTh :isError="false">
              旧姓 または 外国名
              <RequiredText v-show="formUserInputFields.oldSurname.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <div class="d-flex flex-shrink-0 mr-2">
                  <el-col class="u-w--50"><FormLabel>漢字</FormLabel></el-col>
                  <el-col class="u-w--460 flex-shrink-0">
                    <el-input
                      placeholder=""
                      maxlength="50"
                      name="old_surname"
                      v-model="form.old_surname"
                      :id="formUserInputFields.oldSurname.key"
                      @input="handleSurnameInput()"
                    />
                  </el-col>
                </div>
              </el-row>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <div class="d-flex flex-shrink-0 mr-2">
                  <el-col class="u-w--50"><FormLabel>カナ</FormLabel></el-col>
                  <el-col class="u-w--460 flex-shrink-0">
                    <el-input
                      placeholder=""
                      maxlength="50"
                      name="old_surname_kana"
                      v-model="form.old_surname_kana"
                      :id="formUserInputFields.oldSurnameKana.key"
                    />
                  </el-col>
                </div>
              </el-row>
              <FormNotice>苗字を1年以内に変更されている場合は必ずご入力ください</FormNotice>
              <FormNotice>外国名がある場合は必ずご入力ください</FormNotice>
              <ErrorMessage class="error-old_surname-string"></ErrorMessage>
              <ErrorMessage class="error-old_surname_kana-string"></ErrorMessage>
              <!-- <ErrorMessage class="error-old_surname_kana-kana"></ErrorMessage> -->
              <ErrorMessage class="error-old_surname_kana-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.sexType.isShow">
            <TableTh :isError="false">
              性別
              <RequiredText v-show="formUserInputFields.sexType.required" />
            </TableTh>
            <td>
              <InputRadio
                name="sex_type"
                :choices="formUserInputFields.sexType.choices"
                :inputRadioVal.sync="form.sex_type"
                :handleChange="
                  ($event) => {
                    onChangeSexType()
                  }
                "
              />
              <ErrorMessage class="error-sex_type-required"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.birthday.isShow">
            <TableTh :isError="false">
              生年月日
              <RequiredText v-show="formUserInputFields.birthday.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="6" class="u-w--200">
                  <el-select
                    name="birthday_year"
                    placeholder=""
                    disabled
                    v-model="form.birthday_year"
                    @change="onChangeBirthday()"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.BirthdayYears(getHasPayment)"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
                <el-col :span="4" class="u-w--150">
                  <el-select
                    name="birthday_month"
                    placeholder=""
                    disabled
                    v-model="form.birthday_month"
                    @change="onChangeBirthday()"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.Months"
                      :key="key"
                      :label="`${item.value}月`"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="4" class="u-w--150">
                  <el-select
                    name="birthday_day"
                    placeholder=""
                    disabled
                    v-model="form.birthday_day"
                    @change="onChangeBirthday()"
                  >
                    <el-option v-for="(item, key) in birthdayDays" :key="key" :label="item.label" :value="item.value" />
                  </el-select>
                </el-col>
              </el-row>
              <ErrorMessage class="error-birthday-required"></ErrorMessage>
              <ErrorMessage class="error-birthday-date"></ErrorMessage>
              <ErrorMessage class="error-birthday-birthday_range"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.postNumber.isShow">
            <TableTh :isError="false">
              郵便番号
              <RequiredText v-show="formUserInputFields.postNumber.required" />
            </TableTh>
            <td>
              <ZipcodeSearch
                :name="formUserInputFields.postNumber.key"
                dataValidationName="post_number_require"
                :zipcodeVal.sync="form.post_number"
                :handleBlur="
                  ($event) => {
                    arrangeAddHyphen($event, 'post_number')
                  }
                "
                :handleClickSearch="onClickSearchPostNumber"
              />
              <FormNotice
                >例)100-0000 郵便番号がわからない場合は<a href="https://www.post.japanpost.jp/zipcode/" target="_blank"
                  >こちら</a
                ></FormNotice
              >
              <ErrorMessage class="error-post_number-required"></ErrorMessage>
              <ErrorMessage class="error-post_number-post"></ErrorMessage>
              <ErrorMessage class="error-post_number_search-message_custom"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.address.isShow">
            <TableTh :isError="false">
              住所
              <RequiredText v-show="formUserInputFields.address.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="24">
                  <FormExample>例: 神奈川県横浜市緑区 1-2-3</FormExample>
                  <el-input
                    :id="formUserInputFields.address.address1.key"
                    :name="formUserInputFields.address.address1.key"
                    :placeholder="formUserInputFields.address.address1.placeholder"
                    v-model="form.street_address1"
                    data-validator-name="street_address1_require"
                    @input="handleStreetInput()"
                  />
                </el-col>
              </el-row>
              <el-row :gutter="10" class="flex-wrap u-mr--10">
                <el-col :span="24">
                  <FormExample>例: ペイパルビル 1037</FormExample>
                  <el-input
                    :name="formUserInputFields.address.address2.key"
                    :placeholder="formUserInputFields.address.address2.placeholder"
                    v-model="form.street_address2"
                  />
                </el-col>
              </el-row>
              <ErrorMessage class="error-street_address1-required"></ErrorMessage>
              <ErrorMessage class="error-street_address1-maxlen"></ErrorMessage>
              <ErrorMessage class="error-street_address1-string"></ErrorMessage>
              <ErrorMessage class="error-street_address1-address"></ErrorMessage>
              <ErrorMessage class="error-street_address2-maxlen"></ErrorMessage>
              <ErrorMessage class="error-street_address2-string"></ErrorMessage>
              <FormAttention>「丁目」や「番地」の登録など、今一度ご登録内容のご確認をお願いします。</FormAttention>
              <FormAttention>部屋番号の前にマンション、アパート名のご登録をお願いします。</FormAttention>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.addressKana.isShow">
            <TableTh :isError="false">
              住所カナ
              <RequiredText v-show="formUserInputFields.addressKana.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="24">
                  <el-input
                    :id="formUserInputFields.addressKana.key"
                    :name="formUserInputFields.addressKana.key"
                    :placeholder="formUserInputFields.addressKana.placeholder"
                    v-model="form.street_address_kana"
                  />
                </el-col>
              </el-row>
              <FormAttention>カタカナのみでご入力ください。</FormAttention>
              <ErrorMessage class="error-street_address_kana-string"></ErrorMessage>
              <ErrorMessage class="error-street_address_kana-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.tel.isShow">
            <TableTh :isError="false">
              自宅TEL
              <RequiredText v-show="formUserInputFields.tel.required" />
            </TableTh>
            <td>
              <PhoneNumberInput
                phoneName1="fixed_phone1"
                phoneName2="fixed_phone2"
                phoneName3="fixed_phone3"
                :phoneModelVal1.sync="form.fixed_phone1"
                :phoneModelVal2.sync="form.fixed_phone2"
                :phoneModelVal3.sync="form.fixed_phone3"
              />
              <ErrorMessage class="error-fixed_phone-integer"></ErrorMessage>
              <ErrorMessage class="error-fixed_phone-string"></ErrorMessage>
              <ErrorMessage class="error-fixed_phone-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.mobile.isShow">
            <TableTh :isError="false">
              携帯TEL
              <RequiredText v-show="formUserInputFields.mobile.required" />
            </TableTh>
            <td>
              <PhoneNumberInput
                phoneName1="mobile_phone1"
                phoneName2="mobile_phone2"
                phoneName3="mobile_phone3"
                :phoneModelVal1.sync="form.mobile_phone1"
                :phoneModelVal2.sync="form.mobile_phone2"
                :phoneModelVal3.sync="form.mobile_phone3"
                phoneNameValidationName1="mobile_phone1_require"
                phoneNameValidationName2="mobile_phone2_require"
                phoneNameValidationName3="mobile_phone3_require"
                :disabled="true"
              />
              <ErrorMessage class="error-mobile_phone-required"></ErrorMessage>
              <ErrorMessage class="error-mobile_phone-integer"></ErrorMessage>
              <ErrorMessage class="error-mobile_phone-string"></ErrorMessage>
              <ErrorMessage class="error-mobile_phone-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.familyAbout.isShow">
            <TableTh :isError="false">
              ご家族について
              <RequiredText v-show="formUserInputFields.familyAbout.required" />
            </TableTh>
            <td>
              <!-- <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10 mb-2">
                                <el-col :span="3" class="u-w--90">配偶者</el-col>
                                <el-col :span="8">
                                    <el-radio v-for="(item, key) in formUserInputFields.family.hasSpouse.choices" :label="item.value" :key="key" :name="formUserInputFields.family.hasSpouse.key" v-model="form.has_spouse">
                                        {{item.value}}
                                    </el-radio>
                                </el-col>
                            </el-row>
                            <ErrorMessage class="error-has_spouse-required"></ErrorMessage>
                            <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10 mb-2">
                                <el-col :span="3" class="u-w--90">親同居</el-col>
                                <el-col :span="8">
                                    <el-radio v-for="(item, key) in formUserInputFields.family.parentLiving.choices" :label="item.value" :key="key" :name="formUserInputFields.family.parentLiving.key" v-model="form.parent_living">
                                        {{item.value}}
                                    </el-radio>
                                </el-col>
                            </el-row>
                            <ErrorMessage class="error-parent_living-required"></ErrorMessage>
                            <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10 mb-2">
                                <el-col :span="3" class="u-w--90">子供</el-col>
                                <el-col :span="3" class="u-w--90">
                                    <el-radio name="child_status" :label="formUserInputFields.family.childStatus.choices[0].value" v-model="form.child_status" @change="onChangeChildStatus($event)">
                                        {{formUserInputFields.family.childStatus.choices[0].value}}
                                    </el-radio>
                                </el-col>
                                <el-col :span="3" class="u-w--90 pl-0 ml-n2">
                                    <el-input :name="formUserInputFields.family.childNumber.key" placeholder="" v-model="form.child_number" :disabled="form.child_status !== '有'"
                                    data-validator-name="child_number_require"
                                    />
                                </el-col>
                                <el-col :span="2">&nbsp;人</el-col>
                                <el-col :span="3" class="u-w--90">
                                    <el-radio name="child_status" :label="formUserInputFields.family.childStatus.choices[1].value" v-model="form.child_status" @change="onChangeChildStatus($event)">
                                        {{formUserInputFields.family.childStatus.choices[1].value}}
                                    </el-radio>
                                </el-col>
                            </el-row>
                            <ErrorMessage class="error-child_status-required"></ErrorMessage>
                            <ErrorMessage class="error-child_number-required_if"></ErrorMessage>
                            <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                                <el-col :span="3" class="u-w--90">その他</el-col>
                                <el-col :span="3" class="u-w--90">
                                    <el-radio
                                        name="others_status"
                                        :label="formUserInputFields.family.othersStatus.choices[0].value"
                                        v-model="form.others_status"
                                        @change="onChangeOthersStatus($event)"
                                    >
                                        {{formUserInputFields.family.othersStatus.choices[0].value}}
                                    </el-radio>
                                </el-col>
                                <el-col :span="3" class="u-w--90 pl-0 ml-n2">
                                    <el-input :name="formUserInputFields.family.othersNumber.key" placeholder="" v-model="form.others_number" :disabled="form.others_status !== '有'"
                                    data-validator-name="others_number_require"
                                    />
                                </el-col>
                                <el-col :span="2">&nbsp;人</el-col>
                                <el-col :span="3" class="u-w--90">
                                    <el-radio
                                        name="others_status"
                                        :label="formUserInputFields.family.othersStatus.choices[1].value"
                                        v-model="form.others_status"
                                        @change="onChangeOthersStatus($event)"
                                    >
                                        {{formUserInputFields.family.othersStatus.choices[1].value}}
                                    </el-radio>
                                </el-col>
                            </el-row>
                            <ErrorMessage class="error-others_status-required"></ErrorMessage>
                            <ErrorMessage class="error-others_number-required_if"></ErrorMessage> -->
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="10" class="u-w--200">
                  <el-select :name="formUserInputFields.familyAbout.key" v-model="form.family_about">
                    <el-option
                      v-for="(item, index) in formUserInputFields.familyAbout.choices"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="text-right" :span="3">&nbsp;同居人数</el-col>
                <el-col :span="3" class="u-w--90">
                  <el-input
                    type="tel"
                    :name="formUserInputFields.familyAboutNumber.key"
                    v-model="form.family_about_number"
                    maxlength="2"
                    class="text-right"
                  />
                </el-col>
                <el-col :span="2">&nbsp;人</el-col>
              </el-row>
              <FormNotice> 結婚されてる方は「配偶者有」を選択してください。</FormNotice>
              <ErrorMessage class="error-family_about-required"></ErrorMessage>
              <ErrorMessage class="error-family_about_number-required"></ErrorMessage>
              <ErrorMessage class="error-family_about_number-integer"></ErrorMessage>
              <ErrorMessage class="error-family_about_number-maxlen"></ErrorMessage>
              <ErrorMessage class="error-family_about_number-limit"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.familyStructure.isShow">
            <TableTh :isError="false">
              世帯人数{{ getHasPayment === 'credit' ? '（同一生計人数）' : '' }}
              <RequiredText v-show="formUserInputFields.familyStructure.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="3" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.familyStructure.key"
                    v-model="form.family_structure"
                    @change="onChangeFamilyStructure"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputFields.familyStructure.choices"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <FormNotice
                >同居・別居に係らず、同一生計で生活しているご家族の人数をご入力ください。（申込者ご本人も含みます）</FormNotice
              >
              <ErrorMessage class="error-family_structure-required"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.residenceClassification.isShow">
            <TableTh :isError="false">
              ご住居
              <RequiredText v-show="formUserInputFields.residenceClassification.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="7" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.residenceClassification.key"
                    v-model="form.residence_classification"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputFields.residenceClassification.choices"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <ErrorMessage class="error-residence_classification-required"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.residencePeriod.isShow">
            <TableTh :isError="false">
              居住年数
              <RequiredText v-show="formUserInputFields.residencePeriod.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <div class="d-flex align-items-center flex-shrink-0 mr-2">
                  <el-col :span="3" class="u-w--200 flex-shrink-0">
                    <el-select
                      :name="formUserInputFields.residencePeriod.year.key"
                      v-model="form.residence_period_year"
                    >
                      <el-option
                        v-for="(item, key) in formUserInputFields.residencePeriod.year.choices"
                        :key="key"
                        :value="item.value"
                        :label="item.label"
                      />
                    </el-select>
                  </el-col>
                </div>
              </el-row>
              <ErrorMessage class="error-residence_period_year-required"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.loanRent.isShow">
            <TableTh :isError="false">
              申込者又はその配偶者の<br>住宅ローン・家賃のお支払い
              <RequiredText v-show="formUserInputFields.loanRent.required" />
            </TableTh>
            <td>
              <InputRadio
                name="loan_rent"
                :choices="formUserInputFields.loanRent.choices"
                :inputRadioVal.sync="form.loan_rent"
                :handleChange="
                  ($event) => {
                    onChangeLoanRent()
                  }
                "
              />
              <ErrorMessage class="error-loan_rent-required"></ErrorMessage>
            </td>
          </TableTr>
        </tbody>
      </table>
    </div>

    <SegmentName v-show="formUserInputFields.householderRelationOptions.isShow">世帯主について</SegmentName>
    <div class="table_block" v-show="formUserInputFields.householderRelationOptions.isShow">
      <table>
        <tbody>
          <TableTr>
            <TableTh :isError="false">
              お申込者と世帯主の関係
              <RequiredText v-show="formUserInputFields.householderRelationOptions.householderRelation.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="6" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.householderRelationOptions.householderRelation.key"
                    v-model="form.householder_relation"
                    :disabled="form.family_structure === 1"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputFields.householderRelationOptions.householderRelation.choices"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <FormNotice>お申込者ご自身と世帯主の方との関係についてご選択ください</FormNotice>
              <FormNotice>ご自身が世帯主の場合は「本人」をご選択ください</FormNotice>
              <FormNotice>配偶者が世帯主の場合は「配偶者」をご選択ください</FormNotice>
              <FormNotice>※「世帯主」とは、その世帯の主たる生計維持者のことを言います</FormNotice>
              <FormNotice>※ {{ getHasPayment === 'credit' ? '生計人数' : '世帯人数' }}が1人の場合は世帯主は本人となります</FormNotice>
              <ErrorMessage class="error-householder_relation-required"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.householderIncome.isShow">
            <TableTh :isError="false">
              世帯主の税込年収
              <RequiredText v-show="formUserInputFields.householderIncome.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="4" class="u-w--90">
                  <el-input
                    :name="formUserInputFields.householderIncome.key"
                    placeholder=""
                    v-model="form.householder_income"
                    data-validator-name="householder_income_require"
                    type="tel"
                    @blur="isComma('householder_income')"
                    @focus="noneComma('householder_income')"
                    class="text-right"
                    maxlength="5"
                  />
                </el-col>
                <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
              </el-row>
              <FormNotice v-show="form.householder_relation === '配偶者'">世帯主・配偶者等の生計を一にする方本人の申告に基づき、ご入力ください。</FormNotice>
              <ErrorMessage class="error-householder_income-required_if"></ErrorMessage>
              <ErrorMessage class="error-householder_income-integer"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.householderIncomeType.isShow">
            <TableTh :isError="false">
              世帯主の所得種類
              <RequiredText v-show="formUserInputFields.householderIncomeType.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="6" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.householderIncomeType.key"
                    v-model="form.householder_income_type"
                    @change="handleChangeHouseholderIncomeType($event)"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputFields.householderIncomeType.choices"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
                <el-col :span="8" class="u-w--240">
                  <el-input
                    :name="formUserInputFields.householderIncomeTypeOtherName.key"
                    placeholder=""
                    v-model="form.householder_income_type_other_name"
                    :disabled="form.householder_income_type !== 'その他'"
                    data-validator-name="householder_income_type_other_name_require"
                  />
                </el-col>
              </el-row>
              <ErrorMessage class="error-householder_income_type-required_if"></ErrorMessage>
              <ErrorMessage class="error-householder_income_type_other_name-required_if"></ErrorMessage>
              <ErrorMessage class="error-householder_income_type_other_name-string"></ErrorMessage>
              <ErrorMessage class="error-householder_income_type_other_name-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.householderMonthlyCreditPayments.isShow">
            <TableTh :isError="false">
              世帯主の<br />クレジット月間支払額
              <RequiredText v-show="formUserInputFields.householderMonthlyCreditPayments.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="3" class="u-w--90 flex-shrink-0">
                  <el-input
                    :name="formUserInputFields.householderMonthlyCreditPayments.key"
                    placeholder=""
                    v-model="form.householder_monthly_credit_payments"
                    data-validator-name="householder_monthly_credit_payments_require"
                    type="tel"
                    @blur="isComma('householder_monthly_credit_payments')"
                    @focus="noneComma('householder_monthly_credit_payments')"
                    class="text-right"
                    maxlength="5"
                  />
                </el-col>
                <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
              </el-row>
              <ErrorMessage class="error-householder_monthly_credit_payments-required_if"></ErrorMessage>
              <ErrorMessage class="error-householder_monthly_credit_payments-integer"></ErrorMessage>
            </td>
          </TableTr>
        </tbody>
      </table>
    </div>

    <!-- 条件により入力項目が消えてしまうので、ブロックごと非表示する -->
    <div v-show="formUserInputFields.parentHouseOptions.isShow">
      <SegmentName>実家(緊急連絡先)情報</SegmentName>
      <div class="table_block">
        <table>
          <tbody>
            <TableTr v-show="formUserInputFields.parentHouseOptions.isShow">
              <TableTh :isError="false">
                郵便番号
                <RequiredText v-show="formUserInputFields.parentHouseOptions.parentsPost.required" />
              </TableTh>
              <td>
                <el-checkbox 
                  @change="handleAddressCopy" 
                  v-model="parents_address_copy_flg"
                >
                  現住所と同じ
                </el-checkbox>
                <ZipcodeSearch
                  name="parents_post"
                  dataValidationName="parents_post_require"
                  :zipcodeVal.sync="form.parents_post"
                  :handleBlur="
                    ($event) => {
                      arrangeAddHyphen($event, 'parents_post')
                    }
                  "
                  :handleClickSearch="onClickSearchParentPostNumber"
                />
                <FormNotice>例)100-0000</FormNotice>
                <FormNotice
                  >例)100-0000 郵便番号がわからない場合は<a
                    href="https://www.post.japanpost.jp/zipcode/"
                    target="_blank"
                    >こちら</a
                  ></FormNotice
                >
                <FormAttention>申込者ご本人以外のご連絡先のご登録をお願いします。</FormAttention>
                <ErrorMessage class="error-parents_post-required"></ErrorMessage>
                <ErrorMessage class="error-parents_post-post"></ErrorMessage>
                <ErrorMessage class="error-parents_post_search-message_custom"></ErrorMessage>
              </td>
            </TableTr>
            <TableTr v-show="formUserInputFields.parentHouseOptions.isShow">
              <TableTh :isError="false">
                住所
                <RequiredText v-show="formUserInputFields.parentHouseOptions.parentsAddress.required" />
              </TableTh>
              <td>
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-input
                      name="parents_address"
                      :placeholder="formUserInputFields.parentHouseOptions.parentsAddress.address.placeholder"
                      v-model="form.parents_address"
                      data-validator-name="parents_address_require"
                    />
                  </el-col>
                </el-row>
                <FormAttention>「丁目」や「番地」の登録など、今一度ご登録内容のご確認をお願いします。</FormAttention>
                <FormAttention>部屋番号の前にマンション、アパート名のご登録をお願いします。</FormAttention>
                <ErrorMessage class="error-parents_address-required"></ErrorMessage>
                <ErrorMessage class="error-parents_address-address"></ErrorMessage>
                <ErrorMessage class="error-parents_address-maxlen"></ErrorMessage>
              </td>
            </TableTr>
            <TableTr v-show="formUserInputFields.parentHouseOptions.isShow">
              <TableTh :isError="false">
                TEL
                <RequiredText v-show="formUserInputFields.parentHouseOptions.phone.required" />
              </TableTh>
              <td>
                <el-checkbox v-model="form.parents_phone_exists" @change="onToggleParentsPhone">
                  固定電話
                </el-checkbox>
                <PhoneNumberInput
                  v-show="form.parents_phone_exists"
                  phoneName1="parents_phone1"
                  phoneName2="parents_phone2"
                  phoneName3="parents_phone3"
                  :phoneModelVal1.sync="form.parents_phone1"
                  :phoneModelVal2.sync="form.parents_phone2"
                  :phoneModelVal3.sync="form.parents_phone3"
                  phoneNameValidationName1="parents_phone1_require_if"
                  phoneNameValidationName2="parents_phone2_require_if"
                  phoneNameValidationName3="parents_phone3_require_if"
                  :phoneBlur1="parentsPhoneValidate"
                  :phoneBlur2="parentsPhoneValidate"
                  :phoneBlur3="parentsPhoneValidate"
                />
                <div class="fx mg_tb_10">
                  <el-checkbox v-model="form.parents_mobile_exists" @change="onToggleParentsMobile">
                    携帯電話
                  </el-checkbox>
                  <div class="fx" v-show="form.parents_mobile_exists">
                    <span>(続柄:</span>
                      <el-col :span="6" class="u-w--200">
                        <el-select
                          :name="'parents_phone_relationship'"
                          v-model="form.parents_phone_relationship"
                          @blur="parentsPhoneValidate"
                          @change="handleChangeParentsPhoneRelationship($event)"
                        >
                          <el-option
                            v-for="(item, key) in formUserInputFields.parentHouseOptions.phone.relationShip.choices"
                            :key="key"
                            :value="item.value"
                            :label="item.label"
                          />
                        </el-select>
                      </el-col> 
                    <span>)</span>
                    <el-col :span="8" class="u-w--240">
                      <el-input
                        :name="formUserInputFields.parentHouseOptions.phone.relationShipOtherName.key"
                        placeholder=""
                        v-model="form.parents_phone_relationship_other_name"
                        :disabled="form.parents_phone_relationship !== 'その他'"
                        maxlength="10"
                        @blur="parentsPhoneValidate"
                      />
                    </el-col>
                  </div>
                </div>
                <PhoneNumberInput
                  v-show="form.parents_mobile_exists"
                  phoneName1="parents_mobile_phone1"
                  phoneName2="parents_mobile_phone2"
                  phoneName3="parents_mobile_phone3"
                  :phoneModelVal1.sync="form.parents_mobile_phone1"
                  :phoneModelVal2.sync="form.parents_mobile_phone2"
                  :phoneModelVal3.sync="form.parents_mobile_phone3"
                  phoneNameValidationName1="parents_mobile_phone1_require"
                  phoneNameValidationName2="parents_mobile_phone2_require"
                  phoneNameValidationName3="parents_mobile_phone3_require"
                  :phoneBlur1="parentsPhoneValidate"
                  :phoneBlur2="parentsPhoneValidate"
                  :phoneBlur3="parentsPhoneValidate"
                />
                <ErrorMessage class="error-parents_phone-integer"></ErrorMessage>
                <ErrorMessage class="error-parents_phone-required"></ErrorMessage>
                <ErrorMessage class="error-parents_phone_relationship-required"></ErrorMessage>
                <ErrorMessage class="error-parents_phone_relationship_other_name-required_if"></ErrorMessage>
                <ErrorMessage class="error-parents_mobile_phone-integer"></ErrorMessage>
              </td>
            </TableTr>
          </tbody>
        </table>
      </div>
    </div>

    <SegmentName>卒業予定・お勤め先・収入</SegmentName>
    <div class="table_block">
      <table>
        <tbody>
          <TableTr v-show="formUserInputFields.occupation.isShow">
            <TableTh :isError="false">
              お勤め先・学校について
              <RequiredText v-show="formUserInputFields.occupation.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="6" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.occupation.key"
                    v-model="form.occupation"
                    @change="onChangeOccupation"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputFields.occupation.choices"
                      :key="key"
                      :value="item.value"
                      :label="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="8" class="u-w--240">
                  <el-input
                    :name="formUserInputFields.occupationOtherName.key"
                    placeholder=""
                    v-model="form.occupation_other_name"
                    :disabled="form.occupation !== 'その他'"
                    data-validator-name="occupation_other_name_require"
                  />
                </el-col>
              </el-row>
              <el-row>
                <el-checkbox name="student_unemployed_flg" 
                  v-show="formUserInputFields.studentUnemployedFlg.isShow" 
                  v-model="form.student_unemployed_flg"
                >
                  <span class="unemplyed_flg">アルバイトをされていない方はチェックを入れて下さい。</span>
                </el-checkbox>
              </el-row>
              <ErrorMessage class="error-occupation-required"></ErrorMessage>
              <ErrorMessage class="error-occupation_other_name-required_if"></ErrorMessage>
              <ErrorMessage class="error-occupation_other_name-string"></ErrorMessage>
              <ErrorMessage class="error-occupation_other_name-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.expectedGraduation.isShow">
            <TableTh :isError="false">
              卒業予定
              <RequiredText v-show="formUserInputFields.expectedGraduation.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col class="u-w--auto">西暦&nbsp;</el-col>
                <el-col :span="5" class="u-w--150">
                  <el-select
                    :name="formUserInputFields.expectedGraduation.year.key"
                    placeholder=""
                    v-model="form.graduate_year"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.GranduateYear(form.application_date_year)"
                      :key="key"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="3" class="u-w--120">
                  <el-select
                    :name="formUserInputFields.expectedGraduation.month.key"
                    placeholder=""
                    v-model="form.graduate_month"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.Months"
                      :key="key"
                      :label="`${item.value}月`"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <ErrorMessage class="error-graduate_year-required_if"></ErrorMessage>
              <ErrorMessage class="error-graduate_month-required_if"></ErrorMessage>
              <ErrorMessage class="error-graduate-required_if"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.companyName.isShow">
            <TableTh :isError="false">
              お勤め先名称
              <RequiredText v-show="formUserInputFields.companyName.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="24">
                  <el-input
                    :name="formUserInputFields.companyName.key"
                    placeholder=""
                    v-model="form.company_name"
                    data-validator-name="company_name_require"
                    :id="formUserInputFields.companyName.key"
                    @input="handleCompanuyNameInput()"
                  />
                </el-col>
              </el-row>
              <FormNotice v-show="form.occupation === '学生（アルバイト）'">アルバイト先を必ず入力してください(通学先の学校名は不可)</FormNotice>
              <ErrorMessage class="error-company_name-required_unless"></ErrorMessage>
              <ErrorMessage class="error-company_name-required_if"></ErrorMessage>
              <ErrorMessage class="error-company_name-string"></ErrorMessage>
              <ErrorMessage class="error-company_name-maxlen"></ErrorMessage
              ><!-- maxlen:40 -->
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.companyNameKana.isShow">
            <TableTh :isError="false">
              お勤め先名称 フリガナ
              <RequiredText v-show="formUserInputFields.companyNameKana.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle">
                <el-col :span="24">
                  <el-input
                    :name="formUserInputFields.companyNameKana.key"
                    placeholder=""
                    v-model="form.company_name_kana"
                    data-validator-name="company_name_kana_require"
                    :id="formUserInputFields.companyNameKana.key"
                  />
                </el-col>
              </el-row>
              <FormNotice>必ず全角カタカナで入力してください</FormNotice>
              <ErrorMessage class="error-company_name_kana-required_unless"></ErrorMessage>
              <ErrorMessage class="error-company_name_kana-required_if"></ErrorMessage>
              <ErrorMessage class="error-company_name_kana-company_kana"></ErrorMessage>
              <ErrorMessage class="error-company_name_kana-string"></ErrorMessage>
              <ErrorMessage class="error-company_name_kana-maxlen"></ErrorMessage>
              <!-- maxlen:40 -->
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.companyPhone.isShow">
            <TableTh :isError="false">
              お勤め先TEL
              <RequiredText v-show="formUserInputFields.companyPhone.required" />
            </TableTh>
            <td>
              <PhoneNumberInput
                phoneName1="company_phone1"
                phoneName2="company_phone2"
                phoneName3="company_phone3"
                :phoneModelVal1.sync="form.company_phone1"
                :phoneModelVal2.sync="form.company_phone2"
                :phoneModelVal3.sync="form.company_phone3"
                phoneNameValidationName1="company_phone1_require"
                phoneNameValidationName2="company_phone2_require"
                phoneNameValidationName3="company_phone3_require"
              />
              <ErrorMessage class="error-company_phone-required_unless"></ErrorMessage>
              <ErrorMessage class="error-company_phone-required_if"></ErrorMessage>
              <ErrorMessage class="error-company_phone-integer"></ErrorMessage>
              <ErrorMessage class="error-company_phone-string"></ErrorMessage>
              <ErrorMessage class="error-company_phone-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.companyJobDescription.isShow">
            <TableTh :isError="false">
              仕事内容
              <RequiredText v-show="formUserInputFields.companyJobDescription.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="7" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.companyJobDescription.key"
                    v-model="form.company_job_description"
                    @change="onChangeJobDescription($event)"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputFields.companyJobDescription.choices"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
                <el-col :span="8" class="u-w--240">
                  <el-input
                    :name="formUserInputFields.companyJobDescriptionOtherName.key"
                    placeholder=""
                    v-model="form.company_job_description_other_name"
                    :disabled="form.company_job_description !== 'その他'"
                    data-validator-name="company_job_description_other_name_require"
                  />
                </el-col>
              </el-row>
              <ErrorMessage class="error-company_job_description-required_unless"></ErrorMessage>
              <ErrorMessage class="error-company_job_description_other_name-required_if"></ErrorMessage>
              <ErrorMessage class="error-company_job_description_other_name-string"></ErrorMessage>
              <ErrorMessage class="error-company_job_description_other_name-maxlen"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.jobDepartment.isShow">
            <TableTh :isError="false">
              所属部課
              <RequiredText v-show="formUserInputFields.jobDepartment.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="24">
                  <el-input
                    :name="formUserInputFields.jobDepartment.key"
                    placeholder=""
                    v-model="form.job_department"
                    data-validator-name="job_department_require"
                  />
                </el-col>
              </el-row>
              <ErrorMessage class="error-job_department-string"></ErrorMessage>
              <ErrorMessage class="error-job_department-maxlen"></ErrorMessage
              ><!-- maxlen:40 -->
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.dispatchedAgent.isShow">
            <TableTh :isError="false">
              出向派遣元
              <RequiredText v-show="formUserInputFields.dispatchedAgent.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle">
                <el-col :span="24">
                  <el-input
                    :name="formUserInputFields.dispatchedAgent.key"
                    placeholder=""
                    v-model="form.dispatched_agent"
                    data-validator-name="dispatched_agent_require"
                  />
                </el-col>
              </el-row>
              <ErrorMessage class="error-dispatched_agent-string"></ErrorMessage>
              <ErrorMessage class="error-dispatched_agent-maxlen"></ErrorMessage
              ><!-- maxlen:40 -->
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.companyPost.isShow">
            <TableTh :isError="false">
              お勤め先郵便番号
              <RequiredText v-show="formUserInputFields.companyPost.required" />
            </TableTh>
            <td>
              <ZipcodeSearch
                name="company_post"
                dataValidationName="company_post_require"
                :zipcodeVal.sync="form.company_post"
                :handleBlur="
                  ($event) => {
                    arrangeAddHyphen($event, 'company_post')
                  }
                "
                :handleClickSearch="onClickSearchCompanyPostNumber"
              />
              <FormNotice
                >例)100-0000 郵便番号がわからない場合は<a href="https://www.post.japanpost.jp/zipcode/" target="_blank"
                  >こちら</a
                ></FormNotice
              >
              <ErrorMessage class="error-company_post-required_unless"></ErrorMessage>
              <ErrorMessage class="error-company_post-post"></ErrorMessage>
              <ErrorMessage class="error-company_post_search-message_custom"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.companyAddress.isShow">
            <TableTh :isError="false">
              お勤め先住所
              <RequiredText v-show="formUserInputFields.companyAddress.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="24">
                  <el-input
                    name="company_address"
                    :placeholder="formUserInputFields.companyAddress.address.placeholder"
                    v-model="form.company_address"
                    data-validator-name="company_address_require"
                  />
                </el-col>
              </el-row>
              <FormAttention>「丁目」や「番地」の登録など、今一度ご登録内容のご確認をお願いします。</FormAttention>
              <FormAttention>部屋番号の前にマンション、アパート名のご登録をお願いします。</FormAttention>
              <ErrorMessage class="error-company_address-required_unless"></ErrorMessage>
              <ErrorMessage class="error-company_address-address"></ErrorMessage>
              <ErrorMessage class="error-company_address-maxlen"></ErrorMessage
              ><!-- maxlen:40 -->
              <ErrorMessage class="error-company_address-string"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.joinDate.isShow">
            <TableTh :isError="false">
              入社年月
              <RequiredText v-show="formUserInputFields.joinDate.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="6" class="u-w--200">
                  <el-select
                    :name="formUserInputFields.joinDate.year.key"
                    placeholder=""
                    v-model="form.join_year"
                    @input="onChangeJoinDate($event)"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.JoinYears()"
                      :key="key"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-col>
                <el-col :span="3" class="u-w--90">
                  <el-select
                    :name="formUserInputFields.joinDate.month.key"
                    placeholder=""
                    v-model="form.join_month"
                    @input="onChangeJoinDate($event)"
                  >
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.Months"
                      :key="key"
                      :label="`${item.value}月`"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <ErrorMessage class="error-join_year-required_unless"></ErrorMessage>
              <ErrorMessage class="error-join_month-required_unless"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.payday.isShow">
            <TableTh :isError="false">
              給料日
              <RequiredText v-show="formUserInputFields.payday.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="3" class="u-w--120">
                  <el-select :name="formUserInputFields.payday.key" placeholder="" v-model="form.payday">
                    <el-option
                      v-for="(item, key) in formUserInputOptionConstants.PayDay()"
                      :key="key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <ErrorMessage class="error-payday-required_unless"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.companyIncome.isShow">
            <TableTh :isError="false">
              税込年収
              <RequiredText v-show="formUserInputFields.companyIncome.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <el-col :span="3" class="u-w--90 flex-shrink-0">
                  <el-input
                    :name="formUserInputFields.companyIncome.key"
                    placeholder=""
                    v-model="form.company_income"
                    data-validator-name="company_income_require"
                    type="tel"
                    @blur="isComma('company_income')"
                    @focus="noneComma('company_income')"
                    class="text-right"
                    maxlength="5"
                  />
                </el-col>
                <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
              </el-row>
              <ErrorMessage class="error-company_income-required_unless"></ErrorMessage>
              <ErrorMessage class="error-company_income-required_if"></ErrorMessage>
              <ErrorMessage class="error-company_income-integer"></ErrorMessage>
              <ErrorMessage class="error-company_income-more"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.sidelineType.isShow">
            <TableTh :isError="false">
              その他収入(年額)
              <RequiredText v-show="formUserInputFields.sidelineType.required" />
            </TableTh>
            <td>
              <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                <div class="d-flex flex-wrap align-items-center">
                  <el-col :span="6" class="u-w--200 flex-shrink-0">
                    <el-select
                      :name="formUserInputFields.sidelineType.key"
                      v-model="form.sideline_type"
                      @change="onChangeSidelineType($event)"
                      clearable
                    >
                      <el-option
                        v-for="(item, key) in formUserInputFields.sidelineType.choices"
                        :key="key"
                        :value="item.value"
                        :label="item.label"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="u-w--240 flex-shrink-0">
                    <el-input
                      :name="formUserInputFields.sidelineOtherName.key"
                      placeholder=""
                      v-model="form.sideline_other_name"
                      :disabled="form.sideline_type !== 'その他'"
                      data-validator-name="sideline_other_name_require"
                      type="text"
                    />
                  </el-col>
                </div>
                <div class="d-flex flex-wrap flex-shrink-0 align-items-center">
                  <el-col :span="3" class="u-w--120 flex-shrink-0">
                    <el-input
                      :name="formUserInputFields.sidelineIncome.key"
                      placeholder=""
                      v-model="form.sideline_income"
                      @blur="isComma('sideline_income')"
                      @focus="noneComma('sideline_income')"
                      class="text-right"
                      type="tel"
                      maxlength="5"
                    />
                  </el-col>
                  <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
                </div>
              </el-row>
              <FormNotice>奨学金は収入に含みません。</FormNotice>
              <ErrorMessage class="error-sideline_other_name-required_if"></ErrorMessage>
              <ErrorMessage class="error-sideline_other_name-string"></ErrorMessage>
              <ErrorMessage class="error-sideline_other_name-maxlen"></ErrorMessage
              ><!-- maxlen:50 -->
              <ErrorMessage class="error-sideline_income-integer"></ErrorMessage>
            </td>
          </TableTr>
          <TableTr v-show="formUserInputFields.isChangeCustomer.isShow">
            <TableTh :isError="false">
              変更届
              <RequiredText v-show="formUserInputFields.isChangeCustomer.required" />
            </TableTh>
            <td>
              <InputRadio
                name="is_change_customer"
                :choices="formUserInputFields.isChangeCustomer.choices"
                :inputRadioVal.sync="form.is_change_customer"
                :handleChange="
                  ($event) => {
                    onChangeIsChangeCustomer()
                  }
                "
              />
              <!-- <el-radio-group data-validator-name="is_change_customer_require" :name="formUserInputFields.isChangeCustomer.key" v-model="form.is_change_customer">
                                <el-radio  v-for="(item, key) in formUserInputFields.isChangeCustomer.choices" :key="key" :label="item.value">{{ item.label }}</el-radio>
                            </el-radio-group> -->
              <FormNotice>ご登録情報をご変更される場合はこちらにチェックを入れてください。</FormNotice>
              <ErrorMessage class="error-is_change_customer-required"></ErrorMessage>
            </td>
          </TableTr>
        </tbody>
      </table>
    </div>

    <div class="btn_wrap">
      <el-button type="primary" icon="el-icon-arrow-left" @click="backPage">前へ戻る</el-button>
      <el-button type="primary" icon="el-icon-arrow-right" @click="nextPage">次へ進む</el-button>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from 'vuex'
import moment from 'moment'
import {wareki, helperGetBirthday, helperSmoothScroll} from '@/js/util/helper'
import {ActbeValidaterFunctions} from '@/js/util/ActbeValidaterFunctions'
// import * as AutoKana from 'vanilla-autokana'
import * as AutoKana from '@/js/util/ActbeAutokana'
import {FormUserInputFields} from '@/js/util/member/formUserInputFields'
import * as FormUserInputOptionConstants from '@/js/util/member/formUserInputOptionConstants'
import {AgeLimit} from '@/js/util/constants'
import {
  ValidationRules,
  ValidationRulesFun,
  ValidationRulesCommon,
  ValidationRulesCredit,
  ValidationRulesAddCredit,
  ValidationRulesInstallment,
  ValidationRulesAddInstallment
} from '@/js/util/member/formUserInputValidationRules'
import {validate, setErrorLaravel} from '@/js/util/validate/validateFunction'
import ErrorMessage from '@/js/components/member/common/Atoms/ErrorMessage'
import FormAttention from '@/js/components/member/common/Atoms/FormAttention'
import FormExample from '@/js/components/member/common/Atoms/FormExample'
import FormLabel from '@/js/components/member/common/Atoms/FormLabel'
import FormNotice from '@/js/components/member/common/Atoms/FormNotice'
import RequiredText from '@/js/components/member/common/Atoms/RequiredText'
import SegmentName from '@/js/components/member/common/Atoms/SegmentName'
import TableTh from '@/js/components/member/common/Molecules/TableTh'
import TableTr from '@/js/components/member/common/Molecules/TableTr'
import PhoneNumberInput from '@/js/components/member/common/Molecules/PhoneNumberInput'
import ZipcodeSearch from '@/js/components/member/common/Molecules/ZipcodeSearch'
import InputRadio from '@/js/components/member/common/Molecules/InputRadio'

const AVF = new ActbeValidaterFunctions()
const CURRENT_CATEGORY = 'credit'
// const CURRENT_CATEGORY = 'installment'

// Auto Kana変数定義
let auto_surname_kana
let auto_first_name_kana
let auto_oldsurname_kana
let auto_street_address_kana
let auto_company_name_kana

export default {
  components: {
    ErrorMessage,
    FormAttention,
    FormLabel,
    FormNotice,
    RequiredText,
    SegmentName,
    TableTh,
    TableTr,
    PhoneNumberInput,
    ZipcodeSearch,
    InputRadio,
    FormExample
  },
  props: ['type'],
  data() {
    return {
      formUserInputFields: {},
      formUserInputOptionConstants: FormUserInputOptionConstants,
      form: {},
      // validationRules: ValidationRules,
      parents_address_copy_flg: false,  // 現住所と実家の同一フラグ
      birthdayDays: [],
      applicationDays: [],
      currentCategory: CURRENT_CATEGORY,
      thirdParty: {
        keiyakun:{
          no: '',
          is_use: false,
        }
      }
    }
  },
  created() {
    this.formUserInputFields = FormUserInputFields(this.getHasPayment, this.form, this.getHasRegistration)
    axios
      .get(`/api/store/keiyakun/info`)
      .then(res => {
        this.thirdParty.keiyakun.is_use = res.data?.is_use
      })
      .catch(() => {})
  },
  mounted() {
    this.$emit('page', 'form-user-input')
    window.scrollTo(0, 0)

    if (this.type === 'change') {
    }

    // Auto Kanaの設定
    auto_surname_kana = AutoKana.bind(
      `#${this.formUserInputFields.name.surname.key}`,
      `#${this.formUserInputFields.nameKana.surname.key}`,
      {katakana: true}
    )
    auto_first_name_kana = AutoKana.bind(
      `#${this.formUserInputFields.name.firstName.key}`,
      `#${this.formUserInputFields.nameKana.firstName.key}`,
      {katakana: true}
    )
    auto_oldsurname_kana = AutoKana.bind(
      `#${this.formUserInputFields.oldSurname.key}`,
      `#${this.formUserInputFields.oldSurnameKana.key}`,
      {katakana: true}
    )
    auto_street_address_kana = AutoKana.bind(
      `#${this.formUserInputFields.address.address1.key}`,
      `#${this.formUserInputFields.addressKana.key}`,
      {katakana: true}
    )
    auto_company_name_kana = AutoKana.bind(
      `#${this.formUserInputFields.companyName.key}`,
      `#${this.formUserInputFields.companyNameKana.key}`,
      {katakana: true}
    )

    let form_list = _.cloneDeep(this.getForm)

    // SMS認証済 電話番号をフォームに自動入力
    let mobile = {}
    if (this.getTel && this.getTel.length === 11) {
      mobile = {
        mobile_phone1: this.getTel.substr(0, 3),
        mobile_phone2: this.getTel.substr(3, 4),
        mobile_phone3: this.getTel.substr(7, 4)
      }
    }

    // SMS認証済 生年月日をフォームに自動入力
    let birthday = {}
    const selectsYear = FormUserInputOptionConstants.BirthdayYears(this.getHasPayment)
    const selectsMonth = FormUserInputOptionConstants.Months

    if (this.getBirthday && this.getBirthday.length === 8) {
      const year = this.getBirthday.substr(0, 4) // 年取得
      const existYear = selectsYear.some((v) => v.value === year) // 選択肢に存在するか

      const month = this.getBirthday.substr(4, 2).replace(/^0+/, '') // 月取得
      const existMonth = selectsMonth.some((v) => v.value === month) // 選択肢に存在するか

      const day = this.getBirthday.substr(6, 2).replace(/^0+/, '') // 日取得
      const existDay = Number(day) > 0 && Number(day) < 32 // 1 ~ 31日

      if (existYear && existMonth && existDay) {
        birthday = {
          birthday_year: year,
          birthday_month: month,
          birthday_day: day
        }
      }
    }

    // フォーム上書き
    form_list = {
      ...form_list,
      ...mobile,
      ...birthday
    }

    this.form = this.valueConversion(FormUserInputOptionConstants.Conversions, true, form_list)

    // バリデーションを定義
    validate(this.returnValidationRules(), true, this.getHasPayment)

    this.initForm()

    // 生年月日バリデーション強制表示
    if (Object.keys(birthday).length) {
      this.ignitionEvent('blur', 'birthday_year')
      this.ignitionEvent('blur', 'birthday_month')
      this.ignitionEvent('blur', 'birthday_day')
    }

    this.ignitionEvent('change', 'birthday_year')
    this.ignitionEvent('change', 'birthday_month')
    this.ignitionEvent('change', 'birthday_day')

    // 携帯電話番号バリデーション強制表示
    if (Object.keys(mobile).length) {
      this.ignitionEvent('blur', 'mobile_phone1')
      this.ignitionEvent('blur', 'mobile_phone2')
      this.ignitionEvent('blur', 'mobile_phone3')
    }

    // Laravelのバリデーションエラーメッセージ
    if (this.getValidations.length) {
      this.getValidations.map((validate) => {
        setErrorLaravel(validate.key, validate.rule, validate.message, true)
      })
    }
  },
  beforeDestroy() {
    // バリデーションを削除
    validate(this.returnValidationRules(), false, this.getHasPayment)
  },
  methods: {
    nextPage() {
      // 学生アルバイトでアルバイトをしていないケースかつ０円で税込み年収が登録されている場合は税込み年収をnullにする
      // 専業主婦、無職かつ０円で税込み年収が登録されている場合は税込み年収をnullにする
      if((this.form.student_unemployed_flg || ['無職', '専業主婦'].includes(this.form.occupation)) && this.form.company_income == 0) {
        this.form.company_income = null
      }
      const validationRules = this.returnValidationRules()
      for (let key in validationRules) {
        validationRules[key].map(async (validation) => {
          if (validation.rule.match('message_custom')) document.getElementById(key).value = true
          await this.ignitionEvent(validation.event, key)
          // window.requestAnimationFrame(() => { this.ignitionEvent(validation.event,key) });
        })
      }
      // 実家固定電話・実家携帯電話のバリデーション実行
      this.parentsPhoneValidate()

      setTimeout(() => {
        const errors = document.querySelectorAll('.error_message')
        let error_class = ''
        for (var i = 0; i < errors.length; i++) {
          if (errors[i].innerHTML) {
            error_class = errors[i].className
            break
          }
        }
        if (error_class) {
          helperSmoothScroll(error_class)
        } else {
          if (this.getHasPayment === 'installment') {
            const selectedYear = this.form.birthday_year
            const selectedMonth = this.form.birthday_month
            const selectedDay = this.form.birthday_day
            if (selectedYear !== null && selectedMonth !== null && selectedDay !== null) {
              const age = helperGetBirthday(selectedYear, selectedMonth, selectedDay)
              this.updateHasMinors(age < 20) // 未成年
            }
          }
          this.setForm(this.valueConversion(FormUserInputOptionConstants.Conversions, false, this.form))
          this.$emit('next')
        }
      }, 100)
    },
    backPage() {
      this.$emit('back')
    },
    ...mapActions({
      // 未成年かどうかのフラグ更新
      updateHasMinors: 'status/updateHasMinors',
      // formの値の設定する
      setForm: 'userInput/setForm',
      // php側のバリデーションエラー更新
      updateValidationsProductInput: 'userInput/updateValidations'
    }),
    // フォーム初期化
    initForm() {
      // 申込日を本日の日付に設定
      this.form.application_date_year = `${FormUserInputOptionConstants.CurrentDate()[0]}`
      this.form.application_date_month = `${FormUserInputOptionConstants.CurrentDate()[1]}`
      this.form.application_date_day = `${FormUserInputOptionConstants.CurrentDate()[2]}`
      this.onChangeApplicationDate()

      // 生年月日の「年」を申込可能な一番若い年に設定
      // this.form.birthday_year = FormUserInputOptionConstants.BirthdayYears()[0].value;

      this.onChangeBirthday()
    },
    /**
     * バリデーションのルールをレスポンス
     */
    returnValidationRules() {
      let uniqueRule
      if (this.getHasPayment === 'credit') {
        uniqueRule = this.getHasRegistration != 'new' ? ValidationRulesAddCredit : ValidationRulesCredit
      } else {
        uniqueRule = this.getHasRegistration != 'new' ? ValidationRulesAddInstallment : ValidationRulesInstallment
      }
      return ValidationRulesFun(ValidationRulesCommon, uniqueRule)
    },
    /**
     * 実家固定電話と実家携帯電話のinput属性にバリデーション実行
     */
    parentsPhoneValidate() {
      // 実家TELのErrorMessageタグを初期化
      const reqErrorEl = document.querySelector('.error-parents_phone-required')
      reqErrorEl.innerHTML = ''
      const relationErrorEl = document.querySelector('.error-parents_phone_relationship-required')
      relationErrorEl.innerHTML = ''
      const othernmErrorEl = document.querySelector('.error-parents_phone_relationship_other_name-required_if')
      othernmErrorEl.innerHTML = ''

      // 追加申込の場合はバリデーションを実行しない
      if(this.getHasRegistration === 'add') return

      const nocheckMsg = '実家固定電話または実家携帯電話のどちらかを選択してください。'
      const requiredPhoneMsg = '電話番号は必ず入力してください。'
      const requiredRelationshipMsg = '続柄は必ず選択してください。'
      const requiredRelationshipOtherMsg = '実家携帯電話の続柄 (その他)は必ず入力してください。'
      const keyList = [1,2,3]
      let phoneErrorFlg = false
      let mobileErrorFlg = false
      // 実家TELのヘッダ
      const header = reqErrorEl.closest('.js_error').querySelector('.js_error_header')
      header.classList.remove(`is_active_parents_phone_required_origin`)
      header.classList.remove('is_active_parents_phone_relationship_other_name_required_if')

      // バリデーションチェック(どちらか一方にチェックが入っていない場合はエラー判定)
      if(!this.form.parents_phone_exists && !this.form.parents_mobile_exists) {
        reqErrorEl.innerHTML = nocheckMsg
        header.classList.add(`is_active_parents_phone_required_origin`)
        return
      }
      // バリデーションチェック(携帯電話の場合は続柄に値が入っていない場合はエラー判定)
      if(this.form.parents_mobile_exists && !this.form.parents_phone_relationship) {
        relationErrorEl.innerHTML = requiredRelationshipMsg
        header.classList.add(`is_active_parents_phone_required_origin`)
      }
      // バリデーションチェック(携帯電話の場合かつ、続柄がその他で値が入っていない場合はエラー判定)
      if (this.form.parents_phone_relationship === 'その他' && !this.form.parents_phone_relationship_other_name) {
        othernmErrorEl.innerHTML = requiredRelationshipOtherMsg
        header.classList.add(`is_active_parents_phone_required_origin`)
        header.classList.add('is_active_parents_phone_relationship_other_name_required_if')
      }
      // バリデーションチェック(固定電話か携帯電話のどちらか一方が値入っていない場合はエラー判定)
      keyList.map(val => {
        if(this.form.parents_phone_exists) {
          const phoneEl = document.getElementsByName(`parents_phone${val}`)
          if(!phoneErrorFlg && !phoneEl[0].value) phoneErrorFlg = true
        }
        if(this.form.parents_mobile_exists) {
          const mobileEl = document.getElementsByName(`parents_mobile_phone${val}`)
          if(!mobileErrorFlg && !mobileEl[0].value) mobileErrorFlg = true
        }
      })
      if((!mobileErrorFlg && phoneErrorFlg) || mobileErrorFlg) {
        reqErrorEl.innerHTML = requiredPhoneMsg
        if(!header.classList.contains(`is_active_parents_phone_required_origin`)) header.classList.add(`is_active_parents_phone_required_origin`)
      }
    },
    // 申込日
    onChangeApplicationDate() {
      const selectedYear = this.form.application_date_year
      const selectedMonth = this.form.application_date_month
      const selectedDay = this.form.application_date_day
      const selectedLastDay = moment()
      selectedLastDay.year(selectedYear)
      selectedLastDay.month(selectedMonth - 1)
      selectedLastDay.endOf('month')
      const selectedMonthLastDate = selectedLastDay.date()

      if (selectedMonthLastDate < selectedDay) {
        this.form.application_date_day = null
      }

      this.applicationDays = [...Array(selectedMonthLastDate).keys()].map((i) => {
        const tmp = i + 1
        return {
          value: `${tmp}`,
          label: `${tmp}日`
        }
      })
    },
    // 取引を行う目的
    onChangepurposeOfTransaction(e) {
      if (e === 'その他') return
      this.form.purpose_of_transaction_other_name = null
      this.ignitionEvent('blur', 'purpose_of_transaction_other_name')
    },
    onChangeIsForeignGovernment(e) {
      if (e === 'はい') return
      this.form.foreign_government_company = null
      this.ignitionEvent('blur', this.formUserInputFields.foreignGovernmentCompany.key)
    },
    // 性別
    onChangeSexType() {
      this.ignitionEvent('blur', 'sex_type')
    },
    // 変更届
    onChangeIsChangeCustomer() {
      this.ignitionEvent('blur', 'is_change_customer')
    },
    // 生年月日選択
    onChangeBirthday() {
      const selectedYear = this.form.birthday_year
      const selectedMonth = this.form.birthday_month
      const selectedDay = this.form.birthday_day
      const selectedLastDay = moment()
      selectedLastDay.year(selectedYear)
      selectedLastDay.month(selectedMonth - 1)
      selectedLastDay.endOf('month')
      const selectedMonthLastDate = selectedLastDay.date()

      if (selectedMonthLastDate < selectedDay) {
        this.form.birthday_day = null
      }

      this.birthdayDays = [...Array(selectedMonthLastDate).keys()].map((i) => {
        const tmp = i + 1
        return {
          value: `${tmp}`,
          label: `${tmp}日`
        }
      })

      // if ( selectedYear !== null && selectedMonth !== null && selectedDay !== null ) {
      //     const birthday = moment().year(selectedYear).month(selectedMonth - 1).date(selectedDay).format('YYYY-MM-DD');
      //     const age = moment().diff(birthday, 'years');
      //     const age = helperGetBirthday(selectedYear, selectedMonth, selectedDay);
      //     this.validationRules.birthday_range.isError = (age < AgeLimit.low || AgeLimit.high < age);
      // }
    },
    /**
     * 現住所の"郵便番号"と"住所"の値を実家住所にコピー
     */
    handleAddressCopy() {
      if(this.parents_address_copy_flg) {
        this.form.parents_post = this.form.post_number
        this.form.parents_address = (this.form.street_address1 ?? '') + (this.form.street_address2 ?? '')
        return
      }
      this.form.parents_post = null
      this.form.parents_address = null
    },
    // 郵便番号検索
    onClickSearchPostNumber() {
      const result = document.getElementById('post_number_search')
      axios
        .get(`/search-address?postcode=${this.form.post_number}`)
        .then((res) => {
          console.log(res.data)
          this.form.street_address1 = res.data.addr1 + res.data.addr2 + res.data.addr3
          this.form.street_address_kana = res.data.kana1 + ' ' + res.data.kana2 + ' ' + res.data.kana3 + ' '
          result.value = true
          this.ignitionEvent('blur', 'post_number_search')
          this.ignitionEvent('input', 'post_number')
          this.ignitionEvent('blur', 'street_address1')
          this.ignitionEvent('input', 'street_address1')
        })
        .catch((res) => {
          // console.log(result.value)
          result.value = false
          // console.log(result.value)
          this.ignitionEvent('blur', 'post_number_search')
          // this.validationRules.post_number_search.isError = true;
        })
    },
    // ご家族 > 子供
    onChangeChildStatus(e) {
      if (e === '有') return
      // this.validationRules.child_number_require.isError = false;
      this.form.child_number = null
      this.ignitionEvent('blur', 'child_number')
    },
    // ご家族 > その他
    onChangeOthersStatus(e) {
      if (e === '有') return
      // this.validationRules.others_number_require.isError = false;
      this.form.others_number = null
      this.ignitionEvent('blur', 'others_number')
    },
    onChangeFamilyStructure(e) {
      // 「生計人数: 1人（ご本人様のみ）」を選択時「お申込者と世帯主の関係: 本人」で固定
      if (e === 1) {
        this.form.householder_relation = '本人'
      }
    },
    // 世帯主の所得種類
    handleChangeHouseholderIncomeType(e) {
      if (e === 'その他') return
      // this.validationRules.householder_income_type_other_name_require.isError = false;
      this.form.householder_income_type_other_name = null
      this.ignitionEvent('blur', 'householder_income_type_other_name')
    },
    // 実家携帯電話の続柄
    handleChangeParentsPhoneRelationship(e) {
      if (e === 'その他') {
        this.form.parents_phone_relationship_other_name = null
        this.ignitionEvent('blur', 'parents_phone_relationship_other_name')
      }
      // 続柄の変更に応じて実家TELのエラー表示を再判定する（「その他」等の取り残し防止）
      this.parentsPhoneValidate()
    },
    // 実家固定電話チェックボックス変更（チェックを外した際に残存エラーを再判定）
    onToggleParentsPhone() {
      if (!this.form.parents_phone_exists) this.parentsPhoneValidate()
    },
    // 実家携帯電話チェックボックス変更（チェックを外した際に残存エラーを再判定）
    onToggleParentsMobile() {
      if (!this.form.parents_mobile_exists) this.parentsPhoneValidate()
    },
    // 住宅ローン・家賃のお支払い
    onChangeLoanRent() {
      this.ignitionEvent('blur', 'loan_rent')
    },
    // 実家郵便番号検索
    onClickSearchParentPostNumber() {
      const result = document.getElementById('parents_post_search')
      axios
        .get(`/search-address?postcode=${this.form.parents_post}`)
        .then((res) => {
          this.form.parents_address = res.data.addr1 + res.data.addr2 + res.data.addr3
          result.value = true
          this.ignitionEvent('blur', 'parents_post_search')
          this.ignitionEvent('input', 'parents_post')
          this.ignitionEvent('input', 'parents_address')
          this.ignitionEvent('blur', 'parents_address')
        })
        .catch((res) => {
          // this.validationRules.parents_post_search.isError = true;
          result.value = false
          this.ignitionEvent('blur', 'parents_post_search')
        })
    },
    /**
     * お勤め先・学校について
     */
    onChangeOccupation() {
      const init = [
        'graduate_year',
        'graduate_month',
        'company_name',
        'company_name_kana',
        'company_phone1',
        'company_phone2',
        'company_phone3',
        'job_department',
        'dispatched_agent',
        'company_post',
        'company_address',
        'join_year',
        'join_month',
        'payday',
        'company_income',
        'sideline_type',
        'sideline_other_name',
        'student_unemployed_flg',
        'sideline_income',
        'company_job_description',
        'company_job_description_other_name'
      ]
      const has_payment = this.getHasPayment
      const occupation = this.form.occupation
      const installmentTerms = ['学生（アルバイト）', '専業主婦', '無職']
      const loop =
        (has_payment === 'credit' && occupation === '専業主婦') ||
        (has_payment !== 'credit' && installmentTerms.includes(occupation))
          ? init.length
          : 2

      for (let i = 0; i < loop; i++) {
        this.form[init[i]] = null
      }

      // 卒業式の月をデフォルトで3月にする処理
      if (occupation === '学生（アルバイト）' || occupation === '学生') this.form.graduate_month = '3'

      // 自社割賦の学生アルバイトをデフォルトでfalseにする処理
      if (has_payment === 'installment' && (occupation !== '学生（アルバイト）' || occupation !== '学生')) this.form.student_unemployed_flg = null

      // その他以外の選択肢の場合 その他テキストを除去
      if (occupation !== 'その他') this.form.occupation_other_name = null

      this.ignitionEvent('blur', 'occupation_other_name')
    },
    // 仕事内容
    onChangeJobDescription(e) {
      if (e === 'その他') return
      this.form.company_job_description_other_name = null
      this.ignitionEvent('blur', 'company_job_description_other_name')
    },
    // 勤め先郵便番号検索
    onClickSearchCompanyPostNumber() {
      const result = document.getElementById('company_post_search')
      axios
        .get(`/search-address?postcode=${this.form.company_post}`)
        .then((res) => {
          this.form.company_address = res.data.addr1 + res.data.addr2 + res.data.addr3
          result.value = true
          this.ignitionEvent('blur', 'company_post_search')
          this.ignitionEvent('input', 'company_post')
          this.ignitionEvent('input', 'company_address')
          this.ignitionEvent('blur', 'company_address')
        })
        .catch((res) => {
          result.value = false
          // this.validationRules.company_post_search.isError = true;
          this.ignitionEvent('blur', 'company_post_search')
        })
    },
    // その他年収
    onChangeSidelineType(e) {
      if (e === 'その他') return
      // this.validationRules.sideline_other_name_require.isError = false;
      this.form.sideline_other_name = null
    },
    // 入社年月
    onChangeJoinDate(e) {
      this.ignitionEvent('blur', 'join_year')
      this.ignitionEvent('blur', 'join_month')
    },

    /**
     * 郵便番号にハイフンを追加処理
     * @param {event} e
     * @param {string} formKey
     */
    arrangeAddHyphen(e, formKey) {
      if (!e.srcElement.value || e.srcElement.value.match('-') || e.srcElement.value.length < 7) return
      this.form[formKey] = e.srcElement.value.slice(0, 3) + '-' + e.srcElement.value.slice(3, 7)
    },

    /**
     * 姓の自動カナ入力
     */
    handleSurnameInput() {
      setTimeout(() => {
        this.form.surname_kana = auto_surname_kana.elFurigana.value
      }, 0)
    },

    /**
     * 名の自動カナ入力
     */
    handleNameInput() {
      setTimeout(() => {
        this.form.first_name_kana = auto_first_name_kana.elFurigana.value
      }, 0)
    },

    /**
     * 旧姓の自動カナ入力
     */
    handleOldSurnameInput() {
      setTimeout(() => {
        this.form.old_surname_kana = auto_oldsurname_kana.elFurigana.value
      }, 0)
    },

    /**
     * 住所の自動カナ入力
     */
    handleStreetInput() {
      setTimeout(() => {
        this.form.street_address_kana = auto_street_address_kana.elFurigana.value
      }, 0)
    },

    /**
     * 会社名の自動カナ入力
     */
    handleCompanuyNameInput() {
      setTimeout(() => {
        this.form.company_name_kana = auto_company_name_kana.elFurigana.value
      }, 0)
    },

    seachKeiyakunContract() {
      this.$confirm(`取得した情報で上書きされます。`, `けいやくんの書面番号：${this.thirdParty.keiyakun.no}から情報を取得しますか？`, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      })
      .then(() => {
        axios
          .get(`/api/keiyakun/contract/${this.thirdParty.keiyakun.no}`)
          .then((res) => {
            for(var key in res.data.customer) {
              this.form[key] = res.data.customer[key]
            }
            const imageData = {
              image: res.data.documents.contract.base64.encoded,
              id: res.data.documents.contract.image.id,
              can_delete: true,
              delete: false,
              see: false
            }
            this.form.contract_documents = []
            this.form.contract_documents.push(imageData)
            this.onChangeOccupation()
          })
          .catch(res => {
            this.$alert("けいやくんの書面情報の取得に失敗しました。\n入力された情報が正しいかご確認ください。", '取得エラー', {
              confirmButtonText: '閉じる'
            })
          })
      })
      .catch(() => {})
    },
    clearKeiyakunInputs(){
      this.$confirm(`けいやくん情報連携の取得情報をクリアしますか？`, `取得した情報をクリアします。`, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      })
      .then(() => {
        const emptyData = {
          surname: null,
          first_name: null,
          surname_kana: null,
          first_name_kana: null,
          sex_type: 2,
          occupation: null,
          post_number: null,
          street_address1: null,
          street_address2: null,
          company_name: null,
          company_post: null,
          company_address: null,
        }

        for(var key in emptyData) {
          this.form[key] = emptyData[key]
        }
        
        this.form.contract_documents = []

        this.thirdParty.keiyakun.no = ''

        this.onChangeOccupation()
      })
      .catch(() => {})
    },
  },
  computed: {
    ...mapGetters({
      getHasPayment: 'status/getHasPayment',
      getForm: 'userInput/getForm',
      getHasDoneSms: 'status/getHasDoneSms',
      getValidations: 'userInput/getValidations',
      getHasRegistration: 'status/getHasRegistration',
      getTel: 'customer/getTel',
      getBirthday: 'customer/getBirthday'
    }),
    ...mapState(['userInput'])
  },
  watch: {
    form: {
      async handler(newValue) {
        this.formUserInputFields = FormUserInputFields(this.getHasPayment, newValue, this.getHasRegistration)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.unemplyed_flg {
  font-size: 12px;
}
.fx {
  align-items: center;
  display: flex;
  label {
    margin-bottom: 0;
  }
  span {
    margin: 0 10px
  }
}
.mg_tb_10 {
  margin: 10px 0;
}

.next {
  margin-top: 40px;
  text-align: center;
  .el-button {
    border-radius: 0;
    padding-left: 30px;
    padding-right: 30px;
  }
}

</style>
